module.exports = __webpack_public_path__ + "img/wind-regions.8bbeed62.jpg";